import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { customDateFormat } from "../../utils/helperFunctions";
import { campaignEventRenderPriority } from "../componentConstants";

export default function UserCampaignStatsRow({ row }) {
  const getEventPriority = (event) => {
    const normalizedEvent = (event || "").toLowerCase();
    return (
      campaignEventRenderPriority[normalizedEvent] ?? Number.MAX_SAFE_INTEGER
    );
  };

  const getCampaignStartDateTime = (stats = []) => {
    const eligibleStartEvents = new Set([
      "deferred",
      "bounce",
      "delivered",
      "blocked",
    ]);

    const step1Matches = (stats || []).filter((s) => {
      const stepNo = s?.eventStepNumber;
      const event = (s?.event || "").toLowerCase();
      return stepNo === 1 && eligibleStartEvents.has(event) && s?.eventTime;
    });

    if (step1Matches.length === 0) return null;

    step1Matches.sort(
      (a, b) => new Date(a.eventTime).getTime() - new Date(b.eventTime).getTime(),
    );

    return step1Matches[0]?.eventTime ?? null;
  };

  const sortCampaignStats = (stats = []) => {
    return [...stats].sort((a, b) => {
      const priorityDiff =
        getEventPriority(a?.event) - getEventPriority(b?.event);
      if (priorityDiff !== 0) return priorityDiff;

      // Stable tie-breaker: event time (oldest first)
      const timeA = new Date(a?.eventTime || 0).getTime();
      const timeB = new Date(b?.eventTime || 0).getTime();
      return timeA - timeB;
    });
  };

  return (
    <Table size="small" sx={{ backgroundColor: "#eff0ef" }}>
      <TableHead>
        <TableRow>
          <TableCell>Campaign Title</TableCell>
          <TableCell>Source</TableCell>
          <TableCell>Start Date</TableCell>
          <TableCell>Sent From</TableCell>
          <TableCell>Step No</TableCell>
          <TableCell>Event</TableCell>
          <TableCell>Event Date</TableCell>
          <TableCell>Event Time</TableCell>
          <TableCell>Clicked Link</TableCell>
          <TableCell>Reason</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {row?.original?.campaigns?.map((campaign, i) =>
          sortCampaignStats(campaign.campaignUserStats)?.map((data) => {
            const eventStepNumber = data?.eventStepNumber;
            const campaignStartDateTime = getCampaignStartDateTime(
              campaign?.campaignUserStats,
            );
            return (
              <TableRow key={"user-table-" + data.id}>
                <TableCell width={300}>
                  {campaign?.campaignTitle || "N/A"}
                </TableCell>
                <TableCell width={100}>
                  {campaign?.campaignSource || "N/A"}
                </TableCell>
                <TableCell width={140}>
                  {campaignStartDateTime
                    ? customDateFormat(campaignStartDateTime, "MM-DD-YYYY")
                    : "N/A"}
                </TableCell>
                <TableCell width={180}>
                  {data?.sentFromEmail || "N/A"}
                </TableCell>
                <TableCell width={100}>
                  {eventStepNumber !== null && eventStepNumber !== undefined ? (
                    <span style={{ fontWeight: 500, color: "#374151" }}>
                      {eventStepNumber}
                    </span>
                  ) : (
                    "N/A"
                  )}
                </TableCell>
                <TableCell width={60}>{data?.event || "N/A"}</TableCell>
                <TableCell width={120}>
                  {data?.eventTime
                    ? customDateFormat(data.eventTime, "MM-DD-YYYY")
                    : "N/A"}
                </TableCell>
                <TableCell width={120}>
                  {data?.eventTime
                    ? customDateFormat(data.eventTime, "hh:mm:ss A")
                    : "N/A"}
                </TableCell>
                <TableCell width={250}>
                  {data?.url ? (
                    <a href={data.url} style={{ color: "#367598" }}>
                      {data.url}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </TableCell>
                <TableCell>{data?.reason || "N/A"}</TableCell>
              </TableRow>
            );
          }),
        )}
      </TableBody>
    </Table>
  );
}
